import React from "react";
import { Link } from "react-router-dom";

export default function About() {
  return (
    <div data-testid="about-page" className="min-h-screen">
      <section className="relative h-[60vh] flex items-end border-b border-white/5">
        <img src="https://images.unsplash.com/photo-1552306062-29a5560e1c31?w=2000" alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-[#0A0A0A]/60 to-transparent" />
        <div className="relative max-w-7xl mx-auto px-6 lg:px-10 pb-12">
          <div className="overline mb-3">Our Story</div>
          <h1 className="font-display text-5xl sm:text-7xl uppercase tracking-tighter max-w-3xl">
            Built On Roads. Forged Through Miles.
          </h1>
        </div>
      </section>

      <section className="max-w-4xl mx-auto px-6 lg:px-10 py-20 lg:py-28">
        <div className="space-y-7 text-lg font-body text-white/80 leading-relaxed">
          <p>
            MileForge began on a battered seat, somewhere between a fog-blanketed
            highway and a tarp-lined campsite. The founder, a rider who had spent
            more years on the road than off, kept running into the same problem:
            gear that looked the part but fell apart when it mattered.
          </p>
          <p>
            MileForge is born from <a href="https://rides.touringcraft.com" target="_blank" rel="noreferrer" className="text-[#D96A1B] hover:underline">Touring Craft</a> — a community of riders, adventurers
            and explorers we've been building since long before this brand existed.
            Every product here carries that DNA: it is shaped by riders, tested
            with riders, and made for riders.
          </p>
          <p>
            Every product in the MileForge catalog is born from this belief — that
            <span className="text-[#D96A1B]"> every mile teaches something</span>. From the
            stitching on a touring jacket to the magnet of a tank bag, nothing
            ships until it has earned it.
          </p>
          <p>
            We test in monsoons. We freeze in the Himalayas. We sand our prototypes
            against Rann salt and Spiti gravel. Then we forge it for you.
          </p>
          <p>
            We are not just building products. We are building a community of riders,
            trekkers, travellers and explorers who believe that the road shapes who
            we become.
          </p>
        </div>

        <div className="grid sm:grid-cols-3 gap-6 mt-16">
          {[
            { k: "100K+", v: "Miles Tested" },
            { k: "12+", v: "Climates Tried" },
            { k: "5,000+", v: "Riders Strong" },
          ].map((s) => (
            <div key={s.v} className="border border-white/10 p-7">
              <div className="font-display text-5xl text-[#D96A1B]">{s.k}</div>
              <div className="mt-2 text-xs uppercase tracking-widest font-display text-white/60">{s.v}</div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <Link to="/shop" className="btn-orange">Explore The Forge</Link>
        </div>
      </section>
    </div>
  );
}
